// JS for block-specific behavior only
console.log('res posts archive block loaded');